import script from "./Numberlogin.vue?vue&type=script&setup=true&lang=js"
export * from "./Numberlogin.vue?vue&type=script&setup=true&lang=js"

import "./Numberlogin.vue?vue&type=style&index=0&id=7bb339aa&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb339aa"]])

export default __exports__